import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectMutationKeys, projectQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useUpdateProjectMutation = (options) => {
  const handleMutation = async ({ projectId, body }) => {
    const config = {
      method: 'patch',
      data: {
        ...body,
        occurred: new Date().toISOString()
      }
    }

    const { data } = await api(`/api/projects/${projectId}`, config)

    return data
  }

  const invalidateRelatedQueries = ({ projectId }) => {
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_MY_PROJECTS_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_LIMIT_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_QUERY, projectId]
    })
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: [projectMutationKeys.UPDATE_PROJECT_MUTATION],
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      invalidateRelatedQueries(variables)
      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
    }
  })
}
